var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cog-input",
      class: { "is-read-only": _vm.readonly, "cog-input--icon": _vm.search }
    },
    [
      _vm.readonly && _vm.type === "url" && _vm.internalValue
        ? [
            _c("a", { attrs: { href: _vm.internalValue, target: "_blank" } }, [
              _vm._v(_vm._s(_vm.internalValue))
            ])
          ]
        : _vm.readonly
        ? [_vm._v(_vm._s(_vm.passwordValue || _vm.internalValue || " "))]
        : _vm.mask
        ? _c(
            "el-input",
            _vm._b(
              {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask.short",
                    value: _vm.mask,
                    expression: "mask",
                    modifiers: { short: true }
                  }
                ],
                ref: "input",
                attrs: {
                  id: _vm.fullId,
                  type: _vm.inputType,
                  value: _vm.internalValue,
                  placeholder: _vm.placeholder,
                  "aria-required": _vm.isRequired ? true : undefined,
                  "aria-describedby": _vm.ariaDescriptions,
                  "aria-invalid": _vm.hasError ? true : undefined
                },
                on: {
                  focus: _vm.handleFocus,
                  blur: _vm.handleBlur,
                  change: _vm.handleChange,
                  input: _vm.handleInput
                },
                scopedSlots: _vm._u([
                  {
                    key: "suffix",
                    fn: function() {
                      return [_vm.search ? _c("i-search") : _vm._e()]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.internalValue,
                  callback: function($$v) {
                    _vm.internalValue = $$v
                  },
                  expression: "internalValue"
                }
              },
              "el-input",
              _vm.$attrs,
              false
            )
          )
        : _c(
            "el-input",
            _vm._b(
              {
                ref: "input",
                attrs: {
                  id: _vm.fullId,
                  autosize: { minRows: _vm.minRows, maxRows: 8 },
                  type: _vm.inputType,
                  value: _vm.internalValue,
                  placeholder: _vm.placeholder,
                  resize: _vm.$parent.isTable ? "none" : "both",
                  "aria-required": _vm.isRequired ? true : undefined,
                  "aria-describedby": _vm.ariaDescriptions,
                  "aria-invalid": _vm.hasError ? true : undefined
                },
                on: {
                  focus: _vm.handleFocus,
                  blur: _vm.handleBlur,
                  change: _vm.handleChange,
                  input: _vm.handleInput
                },
                scopedSlots: _vm._u([
                  {
                    key: "suffix",
                    fn: function() {
                      return [_vm.search ? _c("i-search") : _vm._e()]
                    },
                    proxy: true
                  }
                ])
              },
              "el-input",
              _vm.$attrs,
              false
            )
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }